<template>
  <div class="account-create">
    <h1>Account Create</h1>
    <form>
      <input
        v-model.trim="account.name"
        type="text"
        placeholder="Company Name"
        required
      /><br />
      <input
        v-model.trim="account.street_address"
        type="text"
        placeholder="Street Address"
        required
      /><br />
      <input
        v-model.trim="account.city"
        type="text"
        placeholder="City"
        required
      /><br />
      <input
        v-model.trim="account.state"
        type="text"
        placeholder="State"
        required
      /><br />
      <input
        v-model.trim="account.postal_code"
        type="text"
        placeholder="Postal Code"
        required
      /><br />
      <input
        v-model.trim="account.country"
        type="text"
        placeholder="Country"
        required
      /><br />
      <button type="button" class="button button-300" @click="createAccount">
        Create Account
      </button>
    </form>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  computed: {
    account() {
      // return this.$store.getters.account;
      return "";
    }
  },
  created() {
    // this.$store.dispatch('getAccount', this.$route.params.id);
  },
  methods: {
    createAccount: function() {
      // this.$store.dispatch('createAccount', this.account);
    }
  }
};
</script>
